import { useEffect, useState } from "react"
import { Env, Expr } from "../../shared/Expr"

export function useHashParams() {
  const [hash, setHash] = useState(() => window.location.hash)

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash)
    window.addEventListener("hashchange", onHashChange)
    return () => window.removeEventListener("hashchange", onHashChange)
  }, [])

  const hashParams = new URLSearchParams(hash.slice(1)) // strip '#'
  const params: Env = {}
  hashParams.forEach((value, key) => {
    if (key.startsWith("params.")) {
      params[key.substring("params.".length)] = Expr.lit(value)
    }
  })

  return params
}
